import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import WorkSpaces from './WorkSpaces';
import WorkSpaceDetails from './WorkSpaceDetails';

import { useIsAuthenticated } from "@azure/msal-react";
import { useMsalAuthentication, useMsal } from "@azure/msal-react";
import { InteractionType } from '@azure/msal-browser';
import { MotifProgressLoader } from '@ey-xd/motif-react'

const AppLayout = () => {
    const isAuthenticated = useIsAuthenticated();
    const { login, result, error } = useMsalAuthentication(InteractionType.Redirect);
    const { instance, accounts, inProgress } = useMsal();
    if(!isAuthenticated) {
        const accessTokenRequest = {
            scopes: ["user.read"],
            account: accounts[0],
        };
        if(accounts[0]) {
            instance.acquireTokenSilent(accessTokenRequest)
                .then((accessTokenResponse) => {
                    // Acquire token silent success
                    let accessToken = accessTokenResponse.accessToken
                    sessionStorage.setItem('accessToken', accessToken)
                    sessionStorage.setItem('user', accounts[0].name || '')
                })
                .catch((e) => {
                    console.error(e)
                })
        }

        const loadingStartUp = inProgress === 'startup'
        const loadingLogin = inProgress === 'login'
        const loadingRedirect = inProgress === 'handleRedirect'
        const loadingLogout = inProgress === 'logout'
        return (
            <div>
                {loadingLogin && <p>Logging you in</p>}
                {loadingRedirect && <MotifProgressLoader show={true} />}
                {loadingLogout && <p>Logging you out</p>}
                {!loadingLogin && !loadingStartUp && !loadingRedirect && !loadingLogout && <p>You are not authorized to login</p>}
            </div>
        )
    }
    return (
        <div className="main">
            <Routes>
                <Route
                    path={"/"}
                    element={<Navigate to={"/workspaces"} />}
                />
                <Route exact path={`workspaces/`} element={<WorkSpaces />} />
                <Route exact path={`workspaces/:id`} element={<WorkSpaceDetails />} />
                <Route path='*' exact={true} component={() => <div>Route not found</div>} />
            </Routes>
        </div>
    )
}

export default AppLayout;